var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { filterCTAButtons, getFetchOptions, removePhoneButton, searchForPhoneButton, validateEmail, } from './ButtonUtills';
import { useServicesContext } from '../../context';
import { getFinanceDataFromStore } from '../../utils/leanCheckoutUtils';
export const useButtons = (vehicle, appContext, selectedModality, useFinanceData, configurationService, environmentConfig, showAsText, isTilesButtonMode) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const servicesContext = useServicesContext();
    const audiContentService = servicesContext.getAdditionalService('audi-content-service');
    const logger = ((_a = useServicesContext().getAdditionalService('s2:logger')) !== null && _a !== void 0 ? _a : console);
    let rawCTAButtons = [];
    let configuration;
    if (appContext === 'pdp' || appContext === 'tiles') {
        configuration = (_d = (_c = (_b = audiContentService.getContent()) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.vtpConfiguration) === null || _d === void 0 ? void 0 : _d.fields;
        rawCTAButtons = (_f = (_e = configuration.cta) === null || _e === void 0 ? void 0 : _e.map((button) => button.fields)) !== null && _f !== void 0 ? _f : [];
    }
    else {
        configuration = configurationService === null || configurationService === void 0 ? void 0 : configurationService.getConfiguration();
        rawCTAButtons = (_g = configuration.cta) !== null && _g !== void 0 ? _g : [];
    }
    const scContextId = (configuration === null || configuration === void 0 ? void 0 : configuration.scContextId)
        ? configuration === null || configuration === void 0 ? void 0 : configuration.scContextId
        : undefined;
    const [ctaLiteReservationButton, setCtaLiteReservationButton] = React.useState(undefined);
    const ForcePhoneAsPrimary = ((_h = configuration === null || configuration === void 0 ? void 0 : configuration.scopes) === null || _h === void 0 ? void 0 : _h.forcePhoneAsPrimary)
        ? configuration === null || configuration === void 0 ? void 0 : configuration.scopes.forcePhoneAsPrimary
        : false;
    const phoneWithNumber = ((_j = configuration === null || configuration === void 0 ? void 0 : configuration.scopes) === null || _j === void 0 ? void 0 : _j.phoneWithNumber)
        ? configuration === null || configuration === void 0 ? void 0 : configuration.scopes.phoneWithNumber
        : false;
    const liteReservationButton = rawCTAButtons.find((button) => button.type === 'liteReservation');
    const checkDisplayOption = (liteReservationButton === null || liteReservationButton === void 0 ? void 0 : liteReservationButton.displayOption) === appContext ||
        (liteReservationButton === null || liteReservationButton === void 0 ? void 0 : liteReservationButton.displayOption) === 'both';
    const financeData = getFinanceDataFromStore(vehicle);
    const CTAButtons = filterCTAButtons(rawCTAButtons, vehicle, appContext, selectedModality, useFinanceData, showAsText, isTilesButtonMode, ctaLiteReservationButton, financeData);
    const [initialButtonsState, setinitialButtonsState] = React.useState(CTAButtons);
    const [buttonsState, setButtonsState] = React.useState(CTAButtons);
    const [isDesktop, setIsDesktop] = React.useState(false);
    const PhoneCTA = searchForPhoneButton(CTAButtons, appContext);
    const liteReservationButtonUrl = (_k = liteReservationButton === null || liteReservationButton === void 0 ? void 0 : liteReservationButton.url) !== null && _k !== void 0 ? _k : undefined;
    const fetchOptions = liteReservationButtonUrl
        ? getFetchOptions(environmentConfig, vehicle, liteReservationButton)
        : undefined;
    const showLiteReservedVehicle = validateEmail((_l = vehicle.dealer) === null || _l === void 0 ? void 0 : _l.email) &&
        typeof window !== 'undefined' &&
        (environmentConfig === null || environmentConfig === void 0 ? void 0 : environmentConfig.pdfBaseURL);
    useEffect(() => {
        if (checkDisplayOption) {
            const fetchLiteReservationUrl = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const response = yield fetch(liteReservationButtonUrl, fetchOptions);
                    if (response.status === 201 || response.status === 200) {
                        const liteReservationUrl = yield response.text();
                        if (liteReservationUrl && liteReservationUrl.length > 0) {
                            const ctaLiteReservation = {
                                method: 'GET',
                                type: 'liteReservation',
                                url: liteReservationUrl,
                                target: 'new-window',
                                label: liteReservationButton.label,
                                ariaLabel: liteReservationButton.ariaLabel,
                                displayOption: liteReservationButton.displayOption,
                                reservation: liteReservationButton.reservation,
                                buyableOnline: 'ignored',
                            };
                            let liteReservationFilteredButtons = filterCTAButtons(rawCTAButtons, vehicle, appContext, selectedModality, useFinanceData, showAsText, isTilesButtonMode, ctaLiteReservation, financeData);
                            if (appContext === 'carinfo' && window.matchMedia('(min-width: 480px)').matches) {
                                liteReservationFilteredButtons = removePhoneButton(liteReservationFilteredButtons);
                            }
                            setButtonsState(liteReservationFilteredButtons);
                            setinitialButtonsState(liteReservationFilteredButtons);
                            setCtaLiteReservationButton(ctaLiteReservation);
                        }
                    }
                }
                catch (_a) {
                    logger === null || logger === void 0 ? void 0 : logger.error('error while fetching lite reservation url');
                }
            });
            if (showLiteReservedVehicle && liteReservationButton) {
                fetchLiteReservationUrl();
            }
        }
        return () => { };
    }, [liteReservationButton]);
    const setDeviceType = () => {
        if (!window.matchMedia('(min-width: 480px)').matches) {
            setIsDesktop(false);
        }
        else {
            setIsDesktop(true);
        }
    };
    const handlePhoneButton = () => {
        if (!window.matchMedia('(min-width: 480px)').matches) {
            if (ForcePhoneAsPrimary &&
                (appContext === 'carinfo' || (!isTilesButtonMode && showAsText) || isTilesButtonMode)) {
                const buttonsWithoutPhone = removePhoneButton(buttonsState);
                setButtonsState([PhoneCTA, ...buttonsWithoutPhone]);
            }
            else {
                setButtonsState(initialButtonsState);
            }
        }
        else {
            const buttonsWithoutPhone = removePhoneButton(buttonsState);
            if (appContext === 'carinfo') {
                setButtonsState(buttonsWithoutPhone);
            }
            else {
                setButtonsState(initialButtonsState);
            }
        }
    };
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            setDeviceType();
            window.addEventListener('resize', setDeviceType);
            if (PhoneCTA) {
                handlePhoneButton();
                window.addEventListener('resize', handlePhoneButton);
                return () => {
                    window.removeEventListener('resize', handlePhoneButton);
                    window.removeEventListener('resize', setDeviceType);
                };
            }
            return () => {
                window.removeEventListener('resize', setDeviceType);
            };
        }
        return undefined;
    }, []);
    return {
        financeButtonsState: CTAButtons,
        isDesktop,
        buttonsState,
        scContextId,
        phoneWithNumber,
    };
};
